import './src/main.css'
import BorderBox11 from './src/main.vue'

export default function (Vue) {
  Vue.component(BorderBox11.name, BorderBox11)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/borderBox11/index.js